var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"funtion"}},[_c('router-link',{attrs:{"to":"./list","id":"btn1"}}),_c('router-link',{attrs:{"to":"./chart","id":"btn2"}}),_c('router-link',{attrs:{"to":"./settings","id":"btn3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }